module.exports = __webpack_public_path__ + "img/ansible.202eae98.png";